import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress noisy ResizeObserver browser warnings that are expected from
// libraries like React Flow / MUI when layouts change rapidly. We filter
// them at the window level so they don't trigger the global error handler.
if (typeof window !== 'undefined') {
  const stopResizeObserverError = (event: ErrorEvent) => {
    if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
      event.stopImmediatePropagation();
    }
  };
  window.addEventListener('error', stopResizeObserverError);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
